import * as React from "react";

import TimelapseOutlinedIcon from "@mui/icons-material/TimelapseOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";

const iconStyle = { width: "20px", height: "20px" };
export const OrderStatusEnumActions = [
    {
        id: "na-reserve",
        name: "Mark as Not Available to Reserve",
        color: "primary",
        icon: <FactCheckOutlinedIcon sx={iconStyle} />,
        statuses: ["request", "reserve"],
        types: ["fabric"],
    },
    {
        id: "processing",
        name: "Processing",
        color: "primary",
        icon: <ArrowOutwardOutlinedIcon sx={iconStyle} />,
        statuses: ["pending", "pending_payment"],
    },
    {
        id: "ship",
        name: "Ship",
        color: "primary",
        icon: <LocalShippingOutlinedIcon sx={iconStyle} />,
        statuses: ["processing"],
    },
    {
        id: "ship-cfa",
        name: "Ship CFA",
        color: "primary",
        icon: <LocalShippingOutlinedIcon sx={iconStyle} />,
        statuses: ["pending", "pending_payment", "reserve", "na_reserve", "backorder"],
        types: ["fabric"],
    },
    {
        id: "fraud",
        name: "Mark as Fraud",
        color: "primary",
        icon: <ErrorOutlineOutlinedIcon sx={iconStyle} />,
        statuses: ["pending", "pending_payment", "reserve", "requested_refund"],
    },
    {
        id: "delivered",
        name: "Mark as Delivered",
        color: "primary",
        icon: <CheckOutlinedIcon sx={iconStyle} />,
        statuses: ["shipped"],
    },
    {
        id: "pending-payment",
        name: "Mark as Pending Payment",
        color: "warning",
        icon: <TimelapseOutlinedIcon sx={iconStyle} />,
        statuses: ["pending", "reserve", "backorder"],
    },
    {
        id: "complete",
        name: "Complete",
        color: "primary",
        icon: <CheckOutlinedIcon sx={iconStyle} />,
        statuses: ["delivered"],
    },
    {
        id: "cancel",
        name: "Cancel",
        color: "primary",
        icon: <CancelOutlinedIcon sx={iconStyle} />,
        statuses: ["reserve", "pending", "pending_payment", "processing"],
    },
    {
        id: "backorder",
        name: "Backorder",
        color: "warning",
        icon: <TimelapseOutlinedIcon sx={iconStyle} />,
        statuses: ["na_reserve"],
    },
    {
        id: "reserve",
        name: "Mark as Reserve",
        color: "primary",
        icon: <FactCheckOutlinedIcon sx={iconStyle} />,
        statuses: ["request", "na_reserve"],
        types: ["fabric"],
    },
    {
        id: "order",
        name: "Order",
        color: "primary",
        icon: <FactCheckOutlinedIcon sx={iconStyle} />,
        statuses: ["request", "reserve", "pending_payment", "backorder", "na_reserve"],
        types: ["fabric"],
    }
];
